import React from "react";
import LoanStepCard from "../../UIComponents/LoanStepCard";
import "./loanProcess.css";

const loanSteps = [
    {
        number: "01",
        heading: "Exclusive Access to 20+ Banks & NBFCs",
        subtext: "Compare & choose the best offer.",
        imgSrc: "/assets/img/sendingMoney.png",
        background: "#CCF8E1",
        rounded:'top-[-15px] left-[-30px]'
    },
    {
        number: "04",
        heading: "Flexible Loan Amounts",
        subtext: "Borrow anywhere between ₹50,000 to ₹25 Lakhs.",
        imgSrc: "/assets/img/cartoonhand.jpg",
        rounded: 'rounded-tl-3xl'
    },
    {
        number: "02",
        heading: "Instant Approval",
        subtext: "No waiting. No delays. Get your loan approved in minutes.",
        imgSrc: "/assets/img/Illustration.png",
        height: '110%',
        width: '120%',
        background: '#CED3ED',
        rounded:'top-[-40px] left-[-20px]'
    },
    {
        number: "05",
        heading: "Pocket-Friendly EMIs",
        subtext: "Competitive rates starting at 10.5% p.a.",
        imgSrc: "/assets/img/astronaut.png",
        rounded: 'rounded-tl-3xl'
    },
    {
        number: "03",
        heading: "Lightning-Fast Disbursal",
        subtext: "Money in your account within 24–48 hours.",
        imgSrc: "/assets/img/lightining.png",
        height: '100%',
        width: '100%',
        rounded: 'rounded-tl-3xl'
    },
    {
        number: "06",
        heading: "No Heavy Paperwork",
        subtext: "100% digital, minimal documentation.",
        imgSrc: "/assets/img/womenonphone.jpg",
        height: '100%',
        width: '100%',
        rounded: 'rounded-tl-3xl'
    },
];
const MobileloanSteps = [
    {
        number: "01",
        heading: "Exclusive Access to 20+ Banks & NBFCs",
        subtext: "Compare & choose the best offer.",
        imgSrc: "/assets/img/sendingMoney.png",
        background: "#CCF8E1",
        rounded:'top-[-15px] left-[-30px]'
    },
     {
        number: "02",
        heading: "Instant Approval",
        subtext: "No waiting. No delays. Get your loan approved in minutes.",
        imgSrc: "/assets/img/Illustration.png",
        height: '110%',
        width: '120%',
        background: '#CED3ED',
        rounded:'top-[-40px] left-[-20px]'
    },
    {
        number: "03",
        heading: "Lightning-Fast Disbursal",
        subtext: "Money in your account within 24–48 hours.",
        imgSrc: "/assets/img/lightining.png",
        height: '100%',
        width: '100%',
        rounded: 'rounded-tl-3xl'
    },
    {
        number: "04",
        heading: "Flexible Loan Amounts",
        subtext: "Borrow anywhere between ₹50,000 to ₹25 Lakhs.",
        imgSrc: "/assets/img/cartoonhand.jpg",
        rounded: 'rounded-tl-3xl'
    },
   
    {
        number: "05",
        heading: "Pocket-Friendly EMIs",
        subtext: "Competitive rates starting at 10.5% p.a.",
        imgSrc: "/assets/img/astronaut.png",
        rounded: 'rounded-tl-3xl'
    },
    
    {
        number: "06",
        heading: "No Heavy Paperwork",
        subtext: "100% digital, minimal documentation.",
        imgSrc: "/assets/img/womenonphone.jpg",
        height: '100%',
        width: '100%',
        rounded: 'rounded-tl-3xl'
    },
];


export default function HowBusinessLoansWork() {
    return (
        <section className="relative py-12 px-4 max-w-6xl mx-auto mt-5 z-0">
            {/* Overlay background */}
            <div className="absolute h-[90%] top-[0] left-[0%] sm:top-[0] sm:left-[-23%] w-screen sm:h-[50vh] dotted-bg z-[-1]"></div>

            <h2 className="text-4xl xs:text-3xl sm:text-5xl font-bomstad-semibold text-center mb-8">
                Why Choose Us? Because We <br/> Make Borrowing Effortless.
            </h2>
           
            {/* Desktop View */}
            <div className="hidden md:flex justify-between gap-2 sm:mt-8">
                {/* Column 1 */}
                <div className="flex flex-col gap-2 w-1/3">
                    {loanSteps.slice(0, 2).map((step, idx) => (
                        <LoanStepCard key={idx} {...step} />
                    ))}
                </div>

                {/* Column 2 */}
                <div className="flex flex-col gap-2 w-1/3 pt-[100px]">
                    {loanSteps.slice(2, 4).map((step, idx) => (
                        <LoanStepCard key={idx + 2} {...step} />
                    ))}
                </div>

                {/* Column 3 */}
                <div className="flex flex-col gap-2 w-1/3">
                    {loanSteps.slice(4, 6).map((step, idx) => (
                        <LoanStepCard key={idx + 4} {...step} />
                    ))}
                </div>
            </div>

            {/* Mobile View */}
            <div className="grid mt-8 grid-cols-1 gap-6 md:hidden">
                {MobileloanSteps.map((step, idx) => (
                    <LoanStepCard key={idx} {...step} />
                ))}
            </div>
        </section>
    );
}
